export class QuestionType {
  public static readonly TITLE = 0;
  public static readonly RADIO = 1;
  public static readonly CHECKBOX = 2;
  public static readonly SELECT = 3;
  public static readonly TEXTBOX = 4;
  public static readonly TEXTAREA = 5;
  public static readonly SPCHEMICAL = 6;
  public static readonly SPORGANIC = 7;
  public static readonly DATEYYYYMMFROMTO = 8;
  public static readonly PREVIOUS = 9;
  public static readonly LABELTEXT1 = 10;
  public static readonly NONE = 999;
}

export class AnswerStatus {
  public static readonly NON = 1;//未回答
  public static readonly DONE = 2;//回答済
  public static readonly TEMP = 3;//一時保存
}

export class Mode {
  public static readonly EDIT = 1;//編集(USER)
  public static readonly CFM = 2;//確認
  public static readonly PRE = 3;//プレビュー
  public static readonly EDITA = 4;//編集(ADMIN)
  public static readonly END = 9;//修正不可
}

export class Role {
  public static readonly USER = 1;
  public static readonly ADMIN = 2;
  public static readonly SYSTEM = 999;
}


// WEBPACK FOOTER //
// ./src/app/app.constant.ts